import { useEffect, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { Button, Card, CardContent, CardHeader, Chip, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, Grid, IconButton, InputLabel, MenuItem, Select, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TablePagination, TableRow, Typography } from '@mui/material';

import DeleteIcon from '@mui/icons-material/Delete';

import { GrNext } from "react-icons/gr";
import { GrPrevious } from "react-icons/gr";

import { usePages } from '../../../hooks/usePages';

import { TablePaginationActions } from '../../../helpers/TablePaginationActions';

import { RootState } from '../../../store';
import { openSnackbar } from "../../../store/slices/SnackbarSlice";
import { setReducerConceptos } from '../../../store/slices/RecepcionSlice';

import { DialogContentStyle, DialogActionsStyle } from '../../../styles/DialogStyle';
import { TableTheadStyle, TablePaddingStyle } from '../../../styles/TableStyle';

import { ActualizarEstatus } from '../../../connections/comun/RecepcionConnection';
import { AgregarConceptosDemandaInicial } from '../../../connections/comun/DemandaInicialConnection';
import { ObtenerTipoConceptoPorJuicio } from '../../../connections/catalogos/TipoConceptoJuicioConnection';

import { TipoConceptoProps } from '../../../interfaces/catalogos/TipoConceptoInterface';
import { AgregarConceptosDemandaInicialParams } from '../../../interfaces/comun/DemandaInicialInterface';

interface Props {
    numeroSeguimiento:      number;
    handleNext:             () => void;
    handleBack:             () => void;
}

export const RegistrarConceptosPage = ({ numeroSeguimiento, handleNext, handleBack }: Props ) => {

    const dispatch = useDispatch();

    const recepcion = useSelector( ( state: RootState ) => state.recepcion );

    const [tipoConcepto, setTipoConcepto] = useState( 0 );
    const [tipoConceptoArray, setTipoConceptoArray] = useState<TipoConceptoProps[]>( [] );
    
    const [idReferencia, setIdReferencia] = useState(0);

    const [openConfirmacion, setOpenConfirmacion] = useState(false);

    const [rows, setRows] = useState<TipoConceptoProps[]>( [ ] );

    const { page, rowsPerPage, handleChangePage, handleChangeRowsPerPage } = usePages( 5 );    

    const [loadingBack, setLoadingBack] = useState( false );
    const [loadingNext, setLoadingNext] = useState( false );
    const [loadingSave, setLoadingSave] = useState( false );

    const validateFiels = () => {
    
        let valid = true;
        
        if( rows.length === 0 ){
            valid = false;
            dispatch( openSnackbar({ message: 'Debes agregar las Conceptoes', variant: 'warning' }));  
        }                       

        return valid;
    } 

    const handleClicAgregarConcepto = () => {

        if( recepcion.idTipoJuicio === 2 ){

            if( tipoConcepto !== 5 ){

                const tipoConceptoBeneficiario = rows.filter( ( e ) => e.idTipoConcepto === 5 );

                if( tipoConceptoBeneficiario.length !== 0 ){
                    
                    dispatch( openSnackbar({ message: 'El concepto seleccionado no puede agregarse en conjunto con el concepto de Declaración de beneficiario', variant: 'warning' }));            
                    setTipoConcepto( 0 );

                    return;
                }

            }
            else if( tipoConcepto === 5 ){

                const tipoConceptoes = rows.filter( ( e ) => e.idTipoConcepto !== 5 );

                if( tipoConceptoes.length !== 0 ){
                   
                    dispatch( openSnackbar({ message: 'El concepto de Declaración de beneficiario no puede agregarse en conjunto con el(los) concepto(s): ' + tipoConceptoes.map( (e) => e.descripcion).join(', '), variant: 'warning' }));   
                    setTipoConcepto( 0 );

                    return;
                }
            }
            
        }
     
        if( recepcion.idTipoJuicio === 5 || recepcion.idTipoJuicio === 7 ){

            if( tipoConcepto !== 94 ){

                const tipoConceptoBeneficiario = rows.filter( ( e ) => e.idTipoConcepto === 94 );

                if( tipoConceptoBeneficiario.length !== 0 ){
                    
                    dispatch( openSnackbar({ message: 'El concepto seleccionado no puede agregarse en conjunto con el concepto de Medios Preparatorios', variant: 'warning' }));            
                    setTipoConcepto( 0 );

                    return;
                }

            }
            else if( tipoConcepto === 94 ){

                const tipoConceptoes = rows.filter( ( e ) => e.idTipoConcepto !== 94 );

                if( tipoConceptoes.length !== 0 ){
                   
                    dispatch( openSnackbar({ message: 'El concepto de Medios Preparatorios no puede agregarse en conjunto con el(los) concepto(s): ' + tipoConceptoes.map( (e) => e.descripcion).join(', '), variant: 'warning' }));   
                    setTipoConcepto( 0 );

                    return;
                }
            }
            
        }
        
        const tipoConceptoValidate = rows.find( ( e ) => e.idTipoConcepto === tipoConcepto );
        
        if( !tipoConceptoValidate ){
            
            const tipoConceptoData =  tipoConceptoArray.find( ( e ) => e.idTipoConcepto === tipoConcepto );
            
            if( tipoConceptoData ){
                setRows([ ...rows, tipoConceptoData ]);
            }

            setTipoConcepto( 0 );
        }
        else{

            dispatch( openSnackbar({ message: 'La concepto seleccionada ya se encuentra agregada', variant: 'warning' }));  
            setTipoConcepto( 0 );

        }
    }

    const handleClicRemoverConcepto = () => {

        var newArray = rows.filter( ( e ) => e.idTipoConcepto !== idReferencia );

        setRows( newArray );
        setOpenConfirmacion( false );

    }

    const Guardar = async () => {

        const params: AgregarConceptosDemandaInicialParams = { 
            id: recepcion.id ?? '', 
            conceptos: rows,
        };

        const request = await AgregarConceptosDemandaInicial( params );  

        if( request.success ){
            dispatch( setReducerConceptos({ conceptos: rows }) );
        }

        return request;
    }

    const handleGuardar = async () => {

        const validFiels = validateFiels();

        if( !validFiels ){
            return false;
        }

        setLoadingSave( true );

        await Guardar().then( resp => {

            const { success, message } = resp;

            if( success ){

                setTimeout(() => {
                    
                    setLoadingSave( false );
                    dispatch( openSnackbar({ message: 'Se guardó la información correctamente', variant: 'success' }));   

                }, 700);
                
            }
            else {

                setTimeout(() => {                    
                   
                    dispatch( openSnackbar({ message: message, variant: 'error' }));  
                    setLoadingSave( false );

                }, 700);

            }

        });       

    }

    const handleRegresar = async () => {

        setLoadingBack( true );

       if( !recepcion.acuseFirmado ){

            const { success: successGuardar, message: messageGuardar } = await Guardar();
    
            if( !successGuardar ){     

                setTimeout(() => {                    
                 
                    dispatch( openSnackbar({ message: messageGuardar, variant: 'error' }));                      
                    setLoadingBack( false );
    
                }, 700);

            }

        }

        await ActualizarEstatus({ id: recepcion.id ?? '', idEstatus: 4 }).then( resp => {
                
            const { success, message } = resp;

            if( success ){

                setTimeout(() => {

                    handleBack();
                    setLoadingBack( false );
                    
                }, 700);

            }
            else {

                setTimeout(() => {
                    
                    dispatch( openSnackbar({ message: message, variant: 'error' }));  
                    setLoadingBack( false );

                }, 700);

            }

        }); 

    }

    const handleSiguiente = async () => {

        const validFiels = validateFiels();

        if( !validFiels ){
            return false;
        }

        setLoadingNext( true );

        if( !recepcion.acuseFirmado ){

            const { success: successGuardar, message: messageGuardar } = await Guardar();
    
            if( !successGuardar ){          

                setTimeout(() => {
                    
                    dispatch( openSnackbar({ message: messageGuardar, variant: 'error' }));  
                    setLoadingNext( false );
    
                }, 700);

            }

        }

        await ActualizarEstatus({ id: recepcion.id ?? '', idEstatus: 6 }).then( resp => {

            const { success, message } = resp;

            if( success ){

                setTimeout(() => {
                    
                    setLoadingNext( false );
                    handleNext();

                }, 700);

            }
            else {

                setTimeout(() => {
                    
                    dispatch( openSnackbar({ message: message, variant: 'error' }));  
                    setLoadingNext( false );

                }, 700);

            }

        });       

    }

    useEffect(() => {
        
        async function Obtener(){
            
            await ObtenerTipoConceptoPorJuicio( recepcion.idTipoJuicio ?? 0 ).then( resp => {  
                setTipoConceptoArray( resp );   
            });

        }

        if( recepcion.idTipoJuicio ){
            Obtener();
        }

    }, [ recepcion ]);   

    useEffect(() => {
     
        if( recepcion.conceptos?.length !== 0 ){
            setRows( recepcion.conceptos ?? [] );
        }
        
    }, [ recepcion ])    
  
    return (
        <Grid container spacing={3}>

            <Grid size={{ xs: 12, md: 12 }}>

                <Card sx={{ mt: 2 }}>
                
                    <CardHeader 
                        sx={{ backgroundColor: (theme) => theme.palette.primary.main }} 
                        subheader={ 
                            <Grid container spacing={3}>

                                <Grid size={{ md: 6, xs: 6 }}>                                                                    
                                    <Typography variant='h6' sx={{ color: 'white' }}> Registrar prestación(es) o pretensión(es) </Typography> 
                                </Grid>
                            
                                <Grid size={{ md: 6, xs: 6 }} sx={{ textAlign: 'end' }}>
                                    <Chip variant='filled' sx={{ bgcolor: 'white', borderRadius: 2, p: 2 }} label={ <Typography variant='h6'> RT-{ numeroSeguimiento } </Typography>  } />
                                </Grid>

                            </Grid>
                        }
                    />

                    {
                        !recepcion.acuseFirmado
                        &&
                            <CardContent sx={{ p: 3 }}>

                                <Grid container spacing={3}>

                                    <Grid size={{ md: 10, xs: 12 }} >                            
                                        <FormControl fullWidth>
                                            <InputLabel>Tipo de concepto</InputLabel>
                                        
                                            <Select                                                                                    
                                                label="Tipo de concepto"
                                                value={ tipoConcepto }
                                                onChange={ ( e ) => { setTipoConcepto( e.target.value ); } }
                                            >
                                                <MenuItem key={0} value={0}>Selecciona una opción</MenuItem> 
                                                {
                                                    tipoConceptoArray.map( ({ idTipoConcepto, descripcion }) => (
                                                        <MenuItem key={idTipoConcepto} value={idTipoConcepto}>{ descripcion }</MenuItem> 
                                                    ))
                                                }
                                            </Select>

                                        </FormControl>
                                    </Grid> 

                                    <Grid size={{ md: 2, xs: 12 }}>
                                        <Button 
                                            fullWidth
                                            variant="contained"      
                                            disabled={ tipoConcepto === 0 }
                                            onClick={ handleClicAgregarConcepto }
                                        >
                                            Agregar
                                        </Button>
                                    </Grid>   

                                </Grid>   

                            </CardContent>
                    }                
                                    
                </Card>  

            </Grid>

            <Grid size={{ md: 12, xs: 12 }}>

                <TableContainer sx={{ borderRadius: 3, mt: 1 }}>
                                                     
                    <Table sx={{ minWidth: 500 }}>         

                        <TableHead sx={{ ...TableTheadStyle }}>

                            <TableRow sx={{ borderTopLeftRadius: 10, borderTopRightRadius: 10 }}>  
                                <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width:'90%' }}>Tipo de concepto</TableCell>                              
                                { !recepcion.acuseFirmado && <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width:'10%' }}> </TableCell> }                                     
                            </TableRow>

                        </TableHead>

                        <TableBody>         

                            {
                                (rowsPerPage > 0
                                    ? rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                    : rows
                                ).map( ( { idTipoConcepto, descripcion }, index ) => (
                            
                                    <TableRow key={ index }>
                                        <TableCell>{ descripcion }</TableCell>         
                                        {
                                            !recepcion.acuseFirmado
                                            &&
                                                <TableCell sx={{ textAlign: 'end' }}> 
                                                    <IconButton color="primary" onClick={ () => { setIdReferencia( idTipoConcepto ); setOpenConfirmacion( true ); }}>
                                                        <DeleteIcon />
                                                    </IconButton>
                                                </TableCell>
                                        }                     
                                    </TableRow>
                                
                                ))
                            }

                            {
                                rows.length === 0 
                                && 
                                    <TableRow>
                                        <TableCell
                                            colSpan={6}
                                            align="center"
                                            style={{ fontWeight: 'bold', fontSize: 14 }}
                                        >
                                            <Typography variant="caption" color='secondary'> No se han agregado Concepto(es) </Typography>
                                        </TableCell>
                                    </TableRow>
                            }

                        </TableBody>

                        <TableFooter>
                            <TableRow>
                                <TablePagination
                                    rowsPerPageOptions={[ ]}
                                    colSpan={2}
                                    count={rows.length}                                        
                                    rowsPerPage={rowsPerPage}
                                    page={page}                                                                                
                                    onPageChange={ handleChangePage }
                                    onRowsPerPageChange={ handleChangeRowsPerPage }
                                    ActionsComponent={ TablePaginationActions }
                                    labelDisplayedRows={
                                        ({ from, to, count }) => {
                                          return '' + from + '-' + to + ' de ' + count
                                        }
                                    }
                                />
                            </TableRow>
                        </TableFooter>

                    </Table>

                </TableContainer>

            </Grid> 

            <Grid size={{ md: 12, xs: 12 }} sx={{ mt: 3 }}>  

                <Grid container spacing={3}>

                    <Grid size={{ md: 4, xs: 4 }} style={{ textAlign: 'left' }}>
                        <IconButton
                            color='primary'
                            onClick={ handleRegresar }
                            loading={ loadingBack }
                        >
                            <GrPrevious />
                        </IconButton>
                    </Grid>

                    <Grid size={{ md: 4, xs: 4 }} sx={{ textAlign: 'center '}}>
                    
                        {
                            !recepcion.acuseFirmado
                            &&
                                <Button 
                                    fullWidth
                                    variant="contained"
                                    onClick={ handleGuardar }
                                    loading={ loadingSave }
                                > 
                                    Guardar 
                                </Button>
                        }

                    </Grid>

                    <Grid size={{ md: 4, xs: 4 }} style={{ textAlign: 'right' }}>  
                        <IconButton 
                            color='primary'
                            onClick={ handleSiguiente }
                            loading={ loadingNext }
                        > 
                           <GrNext />
                        </IconButton>
                    </Grid>                                        

                </Grid>

            </Grid>     

            <Dialog 
                maxWidth='xs'    
                fullWidth={true}
                disableEscapeKeyDown
                open={ openConfirmacion } onClose={ () => {} }  
            >
                
                <DialogTitle>
                    Confirmación
                </DialogTitle>
                
                <DialogContent sx={ DialogContentStyle }>
                
                    <DialogContentText>
                        ¿Desea quitar el registro seleccionado?
                    </DialogContentText>
                
                </DialogContent>

                <DialogActions sx={ DialogActionsStyle }>
                    <Button color='secondary' onClick={ () => setOpenConfirmacion( false ) }> Cancelar </Button>
                    <Button onClick={ handleClicRemoverConcepto } variant='contained'> Aceptar </Button>
                </DialogActions>
            </Dialog>

        </Grid>
    )
}
